import React from 'react';

import yelpLogo from '@ergeon/icons/svg/icon-yelp-logo.svg';

interface YelpIconProps {
  className?: string;
}

export const YelpIcon: React.FC<YelpIconProps> = ({ className }) => (
  <img alt="Yelp" className={className} src={yelpLogo} />
);
